<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>
        &copy; 2026
        <a :href="t.homeLink" class="footer-link">whatsgbdownloads.com</a>
        {{ t.copyright }}
      </p>
    </div>
    <div class="footer-links">
      <a href="/disclaimer/" class="footer-link">{{ t.disclaimer }}</a>
      |
      <a href="/privacy/" class="footer-link">{{ t.privacy }}</a>
    </div>
  </div>
</footer>
</template>

<script>
const footerLocales = {
  en: {
    homeLink: '/',
    copyright: 'This site only shares guides and news about GBWhatsApp. All rights belong to their owners.',
    disclaimer: 'Disclaimer',
    privacy: 'Privacy Policy',
  },
  pt: {
    homeLink: '/pt/',
    copyright: 'Este site compartilha apenas guias e notícias sobre WhatsApp GB. Todos os direitos pertencem aos seus respectivos proprietários.',
    disclaimer: 'Aviso legal',
    privacy: 'Política de privacidade',
  },
}

export default {
  name: 'Footer',
  computed: {
    lang() {
      return this.$route.meta.lang || (this.$route.path.startsWith('/pt') ? 'pt' : 'en')
    },
    t() {
      return footerLocales[this.lang] || footerLocales.en
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #fff;
  color: #121212;
  padding: 15px 0;
}
@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }
}

.footer-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.footer-links {
  display: flex;
  gap: 15px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  font-size: 15px;

  p {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }

  .footer-links {
    justify-content: center;
    margin-bottom: 10px;
  }

  .footer-note {
    font-size: 10px;
  }
}
</style>
